import React from "react";

import { STRAIN_USER_REVIEW_DISCLAIMER } from "@/constants/disclaimers";
import { Action } from "@/constants/events";
import { useEventTracker } from "@/hooks/useEventTracker";
import useGetSearchParamValues from "@/hooks/useGetSearchParamValues";

import { FilterSection } from "@/components/Filters/FilterSection";
import MedicalDisclaimers from "@/components/MedicalDisclaimers";
import TrackImpression from "@/components/TrackImpression";

import CheckboxSearchList from "./CheckboxSearchList";
import { FilterQueryStringKeyProp, NoFollowLinkProp } from "./DynamicFilters";
import { GroupFilter } from "./types";

const CheckboxFilters: React.FC<{
  filter: GroupFilter;
  defaultOpenKey?: string;
  sectionPadding?: string;
  noFollowLink?: NoFollowLinkProp;
  includeFilterEvents?: boolean;
  eventCategory?: string;
  filterCategory?: string;
  filterQueryStringKey?: FilterQueryStringKeyProp;
}> = ({
  filter,
  defaultOpenKey,
  sectionPadding,
  noFollowLink,
  includeFilterEvents,
  eventCategory,
  filterCategory,
  filterQueryStringKey = (filterName) => filterName,
}) => {
  const queryStringKey = filterQueryStringKey(filter.name);
  const getSearchParamValues = useGetSearchParamValues();
  const selectedValues = getSearchParamValues(queryStringKey);
  const { publishEvent } = useEventTracker();

  return (
    <FilterSection
      title={filter.label}
      numberOfItemsSelected={selectedValues.length}
      openDefault={defaultOpenKey === filter.name}
      open={defaultOpenKey === filter.name}
      sectionPadding={sectionPadding}
    >
      {filter.name === "helps_with" && (
        <MedicalDisclaimers usDisclaimer={STRAIN_USER_REVIEW_DISCLAIMER} />
      )}
      <TrackImpression
        trackingFunction={() => {
          if (
            includeFilterEvents &&
            eventCategory &&
            filterCategory === "Strain name"
          ) {
            publishEvent({
              action: Action.impression,
              category: eventCategory,
              label: "strains",
            });
          }
        }}
      >
        <CheckboxSearchList
          filter={filter}
          noFollowLink={noFollowLink}
          includeFilterEvents={includeFilterEvents}
          eventCategory={eventCategory}
          filterCategory={filterCategory}
          filterQueryStringKey={filterQueryStringKey}
        />
      </TrackImpression>
    </FilterSection>
  );
};

export default CheckboxFilters;
